const f = {
  color: {
    background: "#ffffffff",
    item: {
      text: "#405261ff"
    },
    badge: {
      text: "#314351ff",
      border: "#abb9c7ff"
    },
    separator: "#abb9c7ff"
  }
};
export {
  f as filteredList
};
